module.exports = __webpack_public_path__ + "static/ageLimitImage-eb90a2868f7d66a33b72140c45a77458.png";